/* Directive */

(function () {
  'use strict';

  /**
   * @author Dahang Xu
   * @description Directive of Semafone CreditCard
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')
    .directive('uteSemafoneCreditCard', ['dtmServiceConstants', function (dtmServiceConstants) {

      return {
        restrict: 'AE',
        //TODO - Dahang, can we move the semafone-creditcard.html view to the app/views/uteSemafone directory?
        //TODO when new UTE-UI bower in module 0.8 is done will move template to proper location
        templateUrl: 'modules/uteSemafone/semafone-creditcard.html',
        scope: {
          isNotValidCard: '=?data'
        },
        replace: false,
        controller: 'uteSemafoneCreditCardCtrl',
        controllerAs: 'sm',
        bindToController: true,
        link: link
      };

      function link(scope, element, attributes, controller) {
        if (controller.pciEnabled) {
          element.on("click", handleClick);
        }
        function handleClick() {
          controller.onCardTextclick();
        }
        if(attributes.flowName != '' && attributes.flowName != null && attributes.flowName === 'pay-now'){
          scope.isPayNow = true;
        }else{
          scope.isPayNow = false;
        }
        if(attributes.brtSwitch != '' && attributes.brtSwitch != null && attributes.brtSwitch == 'true'){
          scope.isBrtSwitch = true;
        }else{
          scope.isBrtSwitch = false;
        }

        if(scope.isPayNow && scope.isBrtSwitch){
          scope.isModalWindow = true;
          scope.errorFormPayload = {
            page: dtmServiceConstants.dataLayerTrack.page.makeAPayment.start
          };
        }
      }
    }]);

})();
